import { render, staticRenderFns } from "./IconFile.vue?vue&type=template&id=1c038147&"
import script from "./IconFile.vue?vue&type=script&lang=ts&"
export * from "./IconFile.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports